import React, { useContext } from 'react';

import config from 'config';

import { FormattedMessage } from '@techstyle/react-intl';

import { trackQuickViewModalOpen } from '../../actions/quickView';
import { useAutoBundle2 } from '../../utils/useAutoBundle2';
import {
  UPDATE_CART_ITEM,
  UPDATE_CART_ITEM_GWP,
  useQuickViewContext,
} from '../QuickViewProvider';
import ToastContext from '../ToastContext/ToastContext';

const setId = config.get('public.productTypes.setId');
const byoSetId = config.get('public.productTypes.byoSetId');

export function useBasketItemQuickViewModal({
  gwpProduct,
  product,
  allowGroupedSkus = false,
}) {
  const { hideMessage: hideToastMessage, showMessage: showToastMessage } =
    useContext(ToastContext.Context);
  const autoBundle2Enabled = useAutoBundle2();

  const { openQuickViewModal, setDefaultProductWithSelections } =
    useQuickViewContext();

  return {
    showItemModal: ({ item, trigger }) => {
      const { bundleItems, productTypeId } = product;
      const isRegularSet = productTypeId === setId;
      const isByoSet = !!(productTypeId === byoSetId && bundleItems);
      const singleProduct = isRegularSet || isByoSet ? bundleItems[0] : product;
      const hasCustomText = !!(
        singleProduct.customText || singleProduct.customMessage
      );
      const isGwpProduct = item === gwpProduct;
      if ((isByoSet && !autoBundle2Enabled) || hasCustomText) {
        showToastMessage(
          // @ts-ignore
          <FormattedMessage
            id="global_checkout.quick_view_not_editable"
            defaultMessage="Sorry this item cannot be edited"
          />
        );
        return;
      }
      hideToastMessage();
      if (isByoSet && autoBundle2Enabled) {
        setDefaultProductWithSelections(
          {
            ...item,
            cartLineId: product.cartLineId,
            bundleLabel: product.instanceLabel,
          },
          isRegularSet,
          false,
          allowGroupedSkus
        );
      } else {
        setDefaultProductWithSelections(
          product,
          isRegularSet,
          false,
          allowGroupedSkus
        );
      }

      const cartInteraction = isGwpProduct
        ? UPDATE_CART_ITEM_GWP
        : UPDATE_CART_ITEM;
      openQuickViewModal({ source: 'shopping_bag', cartInteraction });
      trackQuickViewModalOpen({ label: trigger });
    },
  };
}
